var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStacked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 12.705H8.229v-.32H145v.32zM145 24.293H8.229v-.321H145v.321zM145 35.874H8.229v-.32H145v.32zM145 47.462H8.229v-.321H145v.32zM145 59.043H8.229v-.321H145v.321zM145 70.63H8.229v-.32H145v.32zM145 82.219H8.229v-.322H145v.322z",
    fill: "#EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.05 42.394H14.774v39.825h10.278V42.394z",
    fill: "#4179A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.05 7.066H14.774V44.32h10.278V7.066z",
    fill: "#52B2CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.05 7.066H14.774v7.708h10.278V7.066z",
    fill: "#BBE7F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.265 86.015H17.24v1.965h9.025v-1.965zM5.26 81.069H0v1.965h5.26V81.07zM5.26 69.487H0v1.966h5.26v-1.966zM5.26 57.9H0v1.965h5.26V57.9zM5.26 46.319H0v1.965h5.26V46.32zM5.26 34.73H0v1.966h5.26v-1.965zM5.26 11.562H0v1.966h5.26v-1.966zM5.26 23.15H0v1.965h5.26V23.15zM52.729 86.015h-9.025v1.965h9.025v-1.965zM81.126 86.015h-9.024v1.965h9.024v-1.965zM108.811 86.015h-9.025v1.965h9.025v-1.965zM136.136 86.015h-9.025v1.965h9.025v-1.965z",
    fill: "#EEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.248 78.365H35.971v3.854h10.277v-3.854z",
    fill: "#4179A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.248 41.752H35.971v37.897h10.277V41.752z",
    fill: "#52B2CA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.248 41.752H35.971v8.35h10.277v-8.35z",
    fill: "#BBE7F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.014 50.102h-9.635v32.117h9.635V50.102z",
    fill: "#4179A8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.014 12.847h-9.635v37.255h9.635V12.847z",
    fill: "#52B2CA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.014 12.847h-9.635v7.708h9.635v-7.708z",
    fill: "#BBE7F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.955 44.32h-10.277V82.22h10.277V44.32z",
    fill: "#4179A8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.955 7.708h-10.277v37.255h10.277V7.708z",
    fill: "#52B2CA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.955 7.708h-10.277v7.708h10.277V7.708z",
    fill: "#BBE7F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.189 44.32h-10.277V82.22h10.277V44.32z",
    fill: "#4179A8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.189 7.708h-10.277v37.255h10.277V7.708z",
    fill: "#52B2CA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.189 7.708h-10.277v7.708h10.277V7.708z",
    fill: "#BBE7F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.21 71.941H80.935V82.22H91.21V71.94z",
    fill: "#4179A8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.21 63.59H80.935v8.351H91.21v-8.35z",
    fill: "#BBE7F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 1.143H8.229v-.32H145v.32z",
    fill: "#EEE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26 0H0v1.966h5.26V0z",
    fill: "#EEE"
  })));
}
export default SvgStacked;